<template>
  <div class="progress">
    <div class="progress-bar">
      <div :style="`width: ${progress}%;`"></div>
    </div>
    <p v-if="translations['question']">{{translations['question'] | populateTransaltion(step, length)}}</p>
  </div>
</template>

<script>

export default {
  props: ['length', 'step', 'progress', 'translations'],
  filters: {
    populateTransaltion: function(translation, ...args) {
      let result = translation

      for(const arg of args) {
        result = result.replace('#', arg)
      }

      return result
    }
  }
}

</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.progress
  .progress-bar
    max-width: 120px
    position: relative
    height: 4px
    background: $color-body-bg

  .progress-bar > div
    position: absolute
    height: 100%
    background-color: $color-primary
    -webkit-transition: all .3s ease
    transition: all .3s ease

  p
    font-size: 14px
</style>



// WEBPACK FOOTER //
// src/components/pages/Questionnaire/Elements/ProgressBar.vue